export const JWT_LS_KEY = 'JWT';
export const JWT_EXPIRATION_TIME_LS_KEY = 'JWT_EXPIRATION_TIME';
export const USER_LS_KEY = 'USER';

export const ONE_DAY_IN_MS = 86400000;
export const EXPIRATION_TIME_IN_MS = ONE_DAY_IN_MS;
